import React, { useState, useEffect } from "react";
import s from "./SavePresetModal.module.css";
import { getThemeNames } from "../../../restAPI";

const SavePresetModal = (props) => {
  const [names, setNames] = useState(undefined);
  const [error, setError] = useState(undefined);
  const [warning, setWarning] = useState(undefined);

  useEffect(() => {
    getThemeNames().then((r) => setNames(r));
  }, []);

  const onSubmit = async (e) => {
    e.preventDefault();
    setWarning(undefined);
    setError(undefined);

    const presetName = e.target["presetName"].value;
    const isNew = !names.includes(presetName);

    if (!isNew && warning === undefined) {
      setWarning(`"${presetName}" exists. Overwrite?!`);
    } else if (presetName.length === 0) {
      setError("Empty preset name");
    } else {
      props.onSubmit(presetName, isNew);
      setError(undefined);
    }
  };
  const onCancel = () => {
    setError(undefined);
    setWarning(undefined);
    props.onCancel();
  };

  return (
    <div className={s.modalBack}>
      <div className={s.modal}>
        <form className={s.modalForm} onSubmit={(e) => onSubmit(e)} id="savePresetForm">
          <label form={"presetName"}>Preset name</label>
          <input id={"presetName"} />
          <div className={s.btnsRow}>
            <button
              className={"grinBtn shadow"}
              style={{ background: "white", color: "black" }}
              onClick={onCancel}
              type="button"
            >
              Cancel
            </button>
            <button
              className={"grinBtn shadow"}
              style={{ padding: "5px 20px" }}
              form={"savePresetForm"}
              value={"Submit"}
            >
              Ok
            </button>
          </div>
          {error !== undefined && <p className={s.errorText}>{error}</p>}
          {warning !== undefined && <p className={s.warningText}>{warning}</p>}
        </form>
      </div>
    </div>
  );
};

export default SavePresetModal;
